






























































































































import Vue from 'vue'
import { parseMap, isDisplayShow } from '@/utils/index'
import { processStatusMap, processStatusMapColor } from '@/utils/commonDef'
import { DataTreeNode } from '@/utils/array'
import { cloneDeep } from 'lodash'
import { getPageWorkStationCalendarReport } from '@/api/api'
import { ProductionStatisticsServiceProxy } from '@/service-proxies/app-v2/coproduction.service-proxies'
import { TenantBizFieldServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import {
  WorkStationGroupServiceProxy,
  WorkStationServiceProxy
} from '@/service-proxies/app-v2/workStation.service-proxies'

const prodSticService = new ProductionStatisticsServiceProxy()
const tenantBizFieldServiceProxy = new TenantBizFieldServiceProxy()
const wssp = new WorkStationServiceProxy()
const wsgsp = new WorkStationGroupServiceProxy()

import AdvancedSearch from '@/components/AdvancedSearch'

const status = {
  2: 'working-status'
}
export default Vue.extend({
  name: 'paneContent',
  props: ['currentTab'],
  components: {
    AdvancedSearch
  },
  data() {
    return {
      data: [],
      loading: false,
      searchDto: {
        typeId: '',
        filterPlus: false,
        processStatusList: ['2'],
        workStationIdList: [],
        param: {},
        way: 1,
        planCodeLike: '',
        planIdList: []
      },
      processStatusList: parseMap(processStatusMap),
      productColums: [], // 产品表格的字段
      showColumns: [],
      tableScrollWidth: 0,
      isLoadComplete: false,
      expendKeys: [],
      selectNode: undefined,
      treeData: [],
      tableSources: [],
      workStations: [],
      processStatusMap,
      processStatusMapColor,
      workStationIdList: [],
      exportWorkStationIdList: [], // 导出时勾选的checkbox(工位)
      exportPlanIdList: [], // 导出时勾选的checkbox（计划）
      tabs: ['page_quality_station', 'page_bill_classify_plan'],
      // currentTab: 1
      selectArr: [],
      defaultSelect: {}  
    }
  },
  computed: {
    exportFn() {
      const params = {
        bizCode: 'stat_workstation_calendar',
        bizDataId: this.searchDto.typeId,
        current: '1',
        size: '-1',
        tenantId: ''
      }
      let data = {}
      if (this.currentTab === 1) {
        data = Object.assign({}, this.searchDto, {
          workStationIdList: this.exportWorkStationIdList
        })
      } else {
        data = Object.assign({}, this.searchDto, {
          planIdList: this.exportPlanIdList
        })
      }

      return getPageWorkStationCalendarReport.bind(this, params, data)
    }
  },
  watch: {
    'searchDto.processStatusList'() {
      this.load()
    },
    'searchDto.workStationIdList'(val) {
      this.load()
      this.exportWorkStationIdList = val
    },
    currentTab: {
      handler(val) {
        // console.log('currentTab:', val)
        this.searchDto.way = val // 查看方式 1、工位 2、计划
        if (val === 1) {
          this.searchDto.processStatusList = ['2']
          if (this.searchDto.planCodeLike === '') {
            this.splitTableDataByWorkstation()
          } else {
            this.searchDto.planCodeLike = ''
            this.load()
          }
        } else {
          this.searchDto.processStatusList = ['5']
          if (this.searchDto.workStationIdList.length === 0) {
            this.splitTableDataByPlanCode()
          } else {
            this.searchDto.workStationIdList = []
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  async created() {
    this.getSelectArr();
    this.getTreeList()
    this.load()
  },
  methods: {
    cancelChooseArr(val) {
      this.selectedRowKeys = [];
    },
    getSelectArr() {
      let arr = JSON.parse(localStorage.getItem('coproduction'));
      let  arrX = [];

      for(var i=0; i<arr.length; i++) {
        let obj = {
          label: arr[i].name,
          value: arr[i].id
        }
        arrX.push(obj)
      }
      this.selectArr = arrX;

      this.defaultSelect = {
        key: arr[0].id,
        label: arr[0].name
      }
      this.searchDto.typeId = arr[0].id;

    },
    changeProduction(e) {
      console.log(e);
      this.searchDto.typeId = e.key.toString()
      this.getTableColumn()
      this.load()  
    },
    handleSearch() {
      this.load()
    },
    handleCheck(e, source, index) {
      this.tableSources[index].checked = e.target.checked
      this.exportWorkStationIdList = []
      this.exportPlanIdList = []

      this.tableSources.map(item => {
        if (item.checked === true) {
          if (this.currentTab === 1) {
            this.exportWorkStationIdList.push(item.workStationId)
          } else {
            this.exportPlanIdList.push(item.planId)
          }
        }
      })
    },
    showStatusColor(value) {
      const status = this.searchDto.processStatusList.find((res) => res == value)
      let color = ''
      if (status) {
        color = this.processStatusMapColor[value]
      }
      return color
    },
    inSearchStatus(value) {
      // console.log(value)
      const status = this.searchDto.processStatusList.find((res) => res == value)
      let boolean = false
      if (status) {
        boolean = true
      }
      return boolean
    },
    inputStatus(value) {
      const newTags = [...this.searchDto.processStatusList]
      const status = this.searchDto.processStatusList.find((res) => res == value)
      if (!status) {
        this.searchDto.processStatusList.push(value)
      } else {
        this.searchDto.processStatusList = newTags.filter((res) => res != value)
      }
    },
    reload(data) {
      this.searchDto.filterPlus = true
      this.searchDto.param = data
      this.$nextTick(() => this.load())
    },
    load() {
      this.getTableColumn()
      this.loading = true
      this.tableSources = []
      prodSticService
        .getWorkStationCalendarReport(this.searchDto)
        .then((res) => {
          this.isLoadComplete = true
          this.data = []
          if (res.length) {
            this.data = res
            if (this.currentTab === 1) {
              this.splitTableDataByWorkstation()
            } else {
              this.splitTableDataByPlanCode()
            }
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    pageIndexchange(current, index) {
      let temp = cloneDeep(this.tableSources)
      temp[index].pagination.current = current
      this.tableSources = cloneDeep(temp)
    },
    // 根据工位拆分数据
    splitTableDataByWorkstation() {
      this.loading = true
      let temp = []
      let ids = []
      this.data.forEach((item) => {
        if (!ids.includes(item.workStationId)) {
          ids.push(item.workStationId)
        }
      })
      ids.map((w, i) => {
        let group = {
          workStationId: w,
          workStationName: '',
          workStationCode: '',
          jobs: [],
          pagination: {},
          statusList: [],
          extraClass: '',
          checked: false
        }

        this.data.map((item) => {
          if (item.workStationId === w) {
            group.workStationName = item.workStationName
            group.workStationCode = item.workStationCode
            group.jobs.push(item)
          }
        })

        group.pagination = {
          total: group.jobs.length,
          size: 10,
          current: 1
        }

        group.statusList = []
        group.jobs.map((j) => {
          group.statusList.push(j.workStatus)
        })

        group.extraClass = ''
        if (group.statusList.includes(2)) {
          group.extraClass = 'working-status' // 绿
        } else if (group.statusList.indexOf(2) < 0 && group.statusList.includes(4)) {
          group.extraClass = 'err-status' // 红
        } else if (
          group.statusList.indexOf(2) < 0 &&
          group.statusList.indexOf(4) < 0 &&
          group.statusList.includes(1)
        ) {
          group.extraClass = 'free-status' // 黄
        } else if (
          group.statusList.indexOf(2) < 0 &&
          group.statusList.indexOf(4) < 0 &&
          group.statusList.indexOf(1) < 0 &&
          group.statusList.includes(3)
        ) {
          group.extraClass = 'unused-status' // 灰
        }

        temp.push(group)
      })
      this.tableSources = temp
      this.loading = false
      console.log('根据工位分组：', temp)
    },
    // 根据计划编号拆分数据
    splitTableDataByPlanCode() {
      this.loading = true
      let planCodeList = [], temp = []
      this.data.forEach((item) => {
        if (!planCodeList.includes(item.planCode)) {
          planCodeList.push(item.planCode)
        }
      })
      planCodeList.map(code => {
        let group = {
          planCode: code,
          planId: '',
          jobs: [],
          pagination: {},
          checked: false
        }
        this.data.map((item) => {
          if (item.planCode === code) {
            group.jobs.push(item)
            group.planId = item.planId
          }
        })
        group.pagination = {
          total: group.jobs.length,
          size: 10,
          current: 1
        }

        temp.push(group)
      })
      this.tableSources = temp
      this.loading = false
      console.log('根据工单分组：', temp)
    },
    async getWorkStationInfos() {
      let params: any = { filter: undefined }
      const { records } = await wssp.getPageWorkStations(1, params, -1)
      this.workStations = records
      return this.workStations
    },
    getTreeList() {
      this.expendKeys = []
      this.selectNode = undefined
      wsgsp.allWorkStationGroupList().then((res) => {
        if (res) {
          const data = res.reduce((total, value) => {
            const key = value.id
            total.push({
              ...value,
              key: key,
              value: key
            })
            /*if (value.isGroup) {
              this.expendKeys.push(key)
            }*/
            return total
          }, [])
          let root = [
            {
              title: this.$t('page_workstation_maintain_station_group'),
              key: '',
              value: '',
              children: []
            }
          ]
          root[0].children = DataTreeNode.arrayToTree(data)
          this.treeData = root
          this.selectNode = ''
        }
      })
    },
    expandKey(value) {
      this.expendKeys = value
    },
    // 获取指定业务的字段列表
    async getTableColumn() {
      this.productColums = []
      this.productColums = await tenantBizFieldServiceProxy.getTenantBizField(
        'stat_workstation_calendar',
        this.searchDto.typeId
      )
      this.handleColumns()
    },
    handleColumns() {
      this.showColumns = []
      if (!this.productColums || !this.productColums.length) {
        return
      }
      // 字段排序
      this.productColums.sort((a, b) => {
        return a.sort - b.sort
      })
      // 字段显隐
      let columns = []
      this.productColums.map((item) => {
        if (isDisplayShow(item.isDisplay, 2)) {
          // 自定义字段：产品类型
          const temp: any = {
            title: item.title,
            key: item.code,
            dataIndex: item.code,
            ellipsis: true
          }
          if (temp.key === 'code') {
            temp.width = 140
          } else {
            temp.width = (temp.title.length + 1) * 20
          }
          if (temp.key === 'processStatus') {
            temp.scopedSlots = { customRender: 'processStatus' }
          }
          columns.push(temp)
        }
      })
      this.showColumns = [...columns]
      let num = this.productColums.filter((item) => isDisplayShow(item.isDisplay, 2)).length
      this.tableScrollWidth = num * 100
    },
    totalFanyi(number: any) {
      const total = this.$t('Total…items')
      return total.replace('{0}', number)
    },
    // 工位状态
    setRowClassName(record) {
      return record.workStatus === 2 ? 'working' : ''
    },
    getChildKeys(tree) {
      if (!tree || !tree.length) {
        return
      }
      tree.map((t) => {
        this.workStationIdList.push(t.key)
        this.getChildKeys(t.children)
      })
    },
    selectWorkStation(value: any, node, e) {
      // console.log(value, node, e)
      this.workStationIdList = []
      this.searchDto.workStationIdList = []
      if (!value) {
        return
      }
      let tree = e.triggerNode.dataRef
      this.getChildKeys(tree.children)
      this.workStationIdList = [value, ...this.workStationIdList]
      this.searchDto.workStationIdList = this.workStationIdList
    }
  }
})
